import { createSelector } from 'reselect'
import {
  networkGroup,
} from '@nocode-works/template/store/selectors/utils'
import routerSelectors from '@nocode-works/template/store/selectors/router'
import userSelectors from 'store/selectors/user'


const email = state => state.appsumo.email
const plan = state => state.appsumo.plan
const plans = state => state.appsumo.plans

const isActive = createSelector(
  email,
  plan,
  (email, plan) => {
    return email && plan ? true : false
  }
)

const isAppsumo = createSelector(
  routerSelectors.route,
  userSelectors.data,
  (route, user) => {
    if(!user || !route) return null
    return (route.name.indexOf('appsumo.') == 0 || user.appsumo_email) ? true : false
  }
)

const activePlan = createSelector(
  plans,
  userSelectors.data,
  (plans, user) => {
    if(!user.appsumo_plan) return null
    return plans.find(plan => plan.id == user.appsumo_plan)
  }
)

const selectors = {
  email,
  plan,
  plans,
  isActive,
  isAppsumo,
  activePlan,
  ...networkGroup('appsumo', [
    'activate',
  ])
}

export default selectors
